module.exports = __webpack_public_path__ + "img/Logo-rond-jaune-fond-transp.4763f76c.png";